export default __webpack_public_path__ + "static/media/shb_logo.7f9a6ab7.jpeg";